module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-9-f6600e8337872a748c562b35e51b4341.svg";